var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"calendar"},[_c('WeekWithDays'),(_vm.showPeriods)?_c('div',{staticClass:"periods"},[_c('Horizontal',{attrs:{"itemID":_vm.periodRoot._id}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }